import React from "react";
import { Link } from "react-router-dom";
import { ArrowDown, ArrowUp } from "lucide-react";
import { SavStatusBadge } from "./SavDossierTab";
import { fmtDate } from "./SavFields";

function Cell({ c, s }) {
  if (c.id === "reference") return <Link to={`/sav/${s.id}`} className="font-mono text-xs text-norea-primary hover:underline" data-testid={`sav-link-${s.id}`}>{s.reference}</Link>;
  if (c.id === "status") return <SavStatusBadge s={s} />;
  const v = c.get(s);
  return <span className="text-xs">{c.date ? fmtDate(v) : v === 0 ? "0" : v || "—"}</span>;
}

export default function SavTable({ items, cols, sort, onSort }) {
  return (
    <div className="bg-white border border-norea-border rounded-md overflow-x-auto">
      <table className="w-full text-sm" data-testid="sav-table">
        <thead className="text-[11px] uppercase tracking-wider text-norea-textMuted bg-norea-bg/60">
          <tr>{cols.map((c) => (
            <th key={c.id} className="text-left font-semibold px-3 py-2 whitespace-nowrap">
              <button onClick={() => onSort({ key: c.id, dir: sort?.key === c.id && sort.dir === "asc" ? "desc" : "asc" })} className="inline-flex items-center gap-1 hover:text-norea-text" data-testid={`sav-sort-${c.id}`}>
                {c.label}{sort?.key === c.id && (sort.dir === "asc" ? <ArrowUp className="w-3 h-3" /> : <ArrowDown className="w-3 h-3" />)}
              </button>
            </th>
          ))}</tr>
        </thead>
        <tbody>
          {items.length === 0 ? <tr><td colSpan={cols.length} className="p-6 text-center italic text-norea-textMuted" data-testid="sav-table-empty">Aucune demande dans cette vue.</td></tr>
            : items.map((s) => (
              <tr key={s.id} className="border-t border-norea-border hover:bg-norea-surfaceHover transition-colors" data-testid={`sav-table-row-${s.id}`}>
                {cols.map((c) => <td key={c.id} className="px-3 py-2 whitespace-nowrap"><Cell c={c} s={s} /></td>)}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
